<div class="flex-1 overflow-auto">
    <kui-card-header class="header d-flex align-items-center text-left p-3 overflow-hidden">
        <kui-card-title class="content-card-title card-title d-block">{{ handler.title }}</kui-card-title>
        <ul class="content-card-actions">
            @if (handler.actionAdd) {
                <li>
                    <kui-icon kui-action name="add" (click)="actionClicked('add', null)" title="{{ 'SHARED.ADD' | translate }}"></kui-icon>
                </li>
            }
            @if (handler.actionReload) {
                <li>
                    <kui-icon kui-action name="refresh" (click)="refresh()" title="{{ 'SHARED.REFRESH' | translate }}"></kui-icon>
                </li>
            }
        </ul>
    </kui-card-header>

    <div class="list-container">
        @if ((!items || items.length === 0) && (!componentRefs || componentRefs.length === 0) && handler.emptyText) {
            <div class="p-4 border-bottom d-flex">
                <div>
                    <kui-icon class="section-icon icon-light mr-3" [fixedWidth]="true" [name]="'warning'" [size]="'xl'"></kui-icon>
                </div>
                <div class="flex-1">
                    <div>{{ handler.emptyText }}</div>
                </div>
                @if (handler.actionAdd) {
                    <div class="text-right pl-3">
                        <button (click)="actionClicked('add', null)" kui-button>
                            {{ "SHARED.ADD" | translate }}
                        </button>
                    </div>
                }
            </div>
        }

        <template #templateContainer></template>

        @for (item of items; track item) {
            <div class="d-flex flex-1">
                <key-listing [hover]="true">
                    <div class="d-flex flex-row flex-1">
                        @if (item.icon) {
                            <key-listing-avatar class="p-1" (click)="onSelected(item)">
                                <kui-icon [name]="item.icon" [fixedWidth]="true" [size]="'xl'"></kui-icon>
                            </key-listing-avatar>
                        }
                        <div class="flex-1" (click)="onSelected(item)">
                            <key-listing-title>{{ item.name }}</key-listing-title>
                            <key-listing-description>
                                <div class="pt-1 muted" [innerHTML]="item.description"></div>
                            </key-listing-description>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-center">
                            @if (handler.actionDelete) {
                                <div (click)="onDelete(item)">
                                    <kui-icon name="delete" title="{{ 'SHARED.DELETE' | translate }}" [size]="'sm'" class="ml-3 icon-light"></kui-icon>
                                </div>
                            }
                        </div>
                    </div>
                </key-listing>
            </div>
        }
    </div>
</div>
